var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlashSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#107DEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0208 3.09633C11.0208 3.2617 11.0208 3.42708 11.0208 3.59245C11.0208 5.40625 11.0261 7.22005 11.0155 9.03385C11.0155 9.25791 11.0791 9.31125 11.2965 9.31125C12.6641 9.30058 14.0318 9.30592 15.3994 9.30592C15.5902 9.30592 15.6856 9.31125 15.569 9.54064C14.0742 12.5174 12.5899 15.4995 11.1056 18.4763C11.0791 18.5296 11.0473 18.5776 10.9731 18.7003C10.9731 18.5296 10.9731 18.4389 10.9731 18.3429C10.9731 16.4598 10.9678 14.5713 10.9784 12.6881C10.9784 12.4054 10.8989 12.3574 10.6392 12.3627C9.28742 12.3734 7.94099 12.3627 6.58925 12.3734C6.37191 12.3734 6.32951 12.336 6.43553 12.128C7.92509 9.15655 9.40405 6.18512 10.8883 3.21369C10.9095 3.16568 10.9413 3.123 10.9678 3.08032C10.9837 3.08566 10.9996 3.09099 11.0208 3.09633Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashSmall);
export default __webpack_public_path__ + "static/media/flash_small.b9a6c7c89f17b0d00a57d9b952a7dcf5.svg";
export { ForwardRef as ReactComponent };